import React, { useState, useEffect } from 'react';
import { isVideoFile } from "../utils/mediaUtils";
import ReactDOM from 'react-dom/client';

function TrippinPostGrid({ posts, navigate, isOwner, isProfile }) {
  const [loadingState, setLoadingState] = useState(() => {
    const initialState = {};
    posts.forEach(post => {
      initialState[post.trippin_post_id] = { loading: true, timeoutId: null };
    });
    return initialState;
  });
console.log(isOwner);
  useEffect(() => {
    const initialState = {};
    posts.forEach(post => {
      initialState[post.trippin_post_id] = { loading: true, timeoutId: null };
    });
    setLoadingState(initialState);
  }, [posts]);

  const handleMediaLoad = (postId) => {
    setLoadingState(prevState => {
      if (!prevState[postId]) return prevState;

      if (!prevState[postId].loading) return prevState;

      const timeoutId = setTimeout(() => {
        setLoadingState(prevState => ({
          ...prevState,
          [postId]: { loading: false, timeoutId: null }
        }));
      }, 800);

      return {
        ...prevState,
        [postId]: { ...prevState[postId], timeoutId }
      };
    });
  };

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '3px', marginTop: '20px', marginLeft: '-15px', marginRight: '-15px'}}>
      {posts.map((post) => {
        const isVideo = isVideoFile(post.background_url);
        const postState = loadingState[post.trippin_post_id] || { loading: true };
        const isLoading = postState.loading;

        return (
          <div
            key={post.trippin_post_id}
            style={{
              position: 'relative',
              width: '100%',
              paddingBottom: 'calc(100% * 4 / 3)',
              overflow: 'hidden',
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              // backgroundColor: '#000',
            }}
            onClick={async () => {
              const { mount } = await import('./TrippinPost/index.js');
              const domNode = document.getElementById('trippin-root');
              if (!domNode) return;
 // clear in case it was already open
              const unmount = () => {
                ReactDOM.createRoot(domNode).unmount();
              };

              mount(domNode, {
                trippin_ids: posts.map(p => p.trippin_post_id),
                selectedTrippinId: post.trippin_post_id,
                source: isOwner ? 'ownProfile' : 'profile',
                offset: 0,
                onExit: ({ exitTrippinId }) => unmount(),
              });
            }}

          >
            {/* Shimmer Effect */}
            {isLoading && (
              <div
                style={{
                  position: 'absolute',
                  width: '100%',
                  height: '100%',
                  background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                  backgroundSize: '200% 100%',
                  animation: 'shimmerAnimation 2s infinite',
                  top: 0,
                  left: 0,
                }}
              />
            )}

            {isVideo ? (
              <video
                src={post.background_url}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  display: isLoading ? 'none' : 'block',
                }}
                autoPlay
                loop
                muted
                playsInline
                onLoadedData={() => handleMediaLoad(post.trippin_post_id)}
              />
            ) : (
              <img
                src={post.background_url || '/defaultBg.jpg'}
                onLoad={() => handleMediaLoad(post.trippin_post_id)}
                style={{
                  position: 'absolute',
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  top: 0,
                  left: 0,
                  display: isLoading ? 'none' : 'block',
                }}
                alt="Post"
              />
            )}

            {/* Country Flags (Top-Right) */}
            {Array.isArray(post.countries) && post.countries.length > 0 && (
              <div
                style={{
                  position: 'absolute',
                  top: '5px',
                  right: '5px',
                  display: 'flex',
                  gap: '4px',
                  padding: '2px 4px',
                  borderRadius: '4px',
                }}
              >
                {post.countries.map((iso) =>
                  typeof iso === 'string' ? (
                    <img
                      key={iso}
                      src={`/assets/flags/${iso.toLowerCase()}.svg`}
                      alt={iso}
                      style={{ width: 20, height: 20, borderRadius: '5px' }}
                    />
                  ) : null
                )}
              </div>
            )}

          </div>
        );
      })}
    </div>
  );
}

export default TrippinPostGrid;